import {LOGIN_USER_RETRAIT, LOGIN_SUCCESS_RETRAIT, LOGOUT_USER_RETRAIT, LOGOUT_USER_SUCCESS_RETRAIT, API_ERROR_RETRAIT, SOCIAL_LOGIN_RETRAIT} from "./actionTypes"

export const loginUserRetrait = (user, history) => {
  return {type: LOGIN_USER_RETRAIT, payload: { user, history }}
}

export const loginSuccessRetrait = user => {
  return { type: LOGIN_SUCCESS_RETRAIT, payload: user, }
}

export const logoutUserRetrait = history => {
  return { type: LOGOUT_USER_RETRAIT, payload: { history }, }
}

export const logoutUserSuccessRetrait = () => {
  return { type: LOGOUT_USER_SUCCESS_RETRAIT, payload: {}, }
}

export const apiErrorRetrait = error => {
  return { type: API_ERROR_RETRAIT, payload: error, }
}

export const socialLoginRetrait = (type, history) => {
  return { type: SOCIAL_LOGIN_RETRAIT, payload: { type, history }, };
};
